import { EntityType } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { UpdateGroupModal } from './update-group-modal/update-group-modal.component';
import { UserGroupCardProps, useUserGroupCard } from './user-group-card.controller';

const USER_GROUP_MODAL_ID = 'user-group-modal';

export const UserGroupCard = (props: UserGroupCardProps) => {
    const viewProps = useUserGroupCard(props);

    return (
        <DefaultContainer
            title={CommonMessage.OBJECTS.GROUP.PLURAL}
            content={
                <div className='flex flex-wrap gap-2'>
                    {viewProps.groups.map((group) => (
                        <PlatformObjectBadge
                            key={group.id}
                            entityType={EntityType.USER_GROUP}
                            id={group.id}
                        />
                    ))}
                </div>
            }
            update={{
                onUpdate: () =>
                    viewProps.openModal(USER_GROUP_MODAL_ID, () => (
                        <UpdateGroupModal
                            groups={viewProps.groups}
                            members={viewProps.members}
                            entity_id={props.entity_id}
                            callback={() => viewProps.fetchGroups()}
                        />
                    ))
            }}
        />
    );
};
